import { __ } from "../../../../../../utils/i18n.js";
// Static affiliate-program metadata. URLs are localized so the German catalogue can point at localized landing pages.
const AFFILIATE_PROGRAM = {
    name: "devowl.io GmbH",
    link: __("https://devowl.io/"),
    terms: __("https://devowl.io/affiliate-terms/"),
    privacy: __("https://devowl.io/privacy-policy/")
};
export { AFFILIATE_PROGRAM };
